import axios from 'axios';
import moment from 'moment';
import download from 'downloadjs';
import { ENTRIES_ENDPOINT, CSV_ENDPOINT, LAST_CSV_ENDPOINT, WEEKLY_ENTRIES_ENDPOINT } from '../api/api';
import { history } from '../routers/AppRouter';

export const ADD_ENTRY = 'ADD_ENTRY';
export const REMOVE_ENTRY = 'REMOVE_ENTRY';
export const EDIT_ENTRY = 'EDIT_ENTRY';
export const SET_ENTRIES = 'SET_ENTRIES';
export const ENTRY_ACTION_ERROR = 'ENTRY_ACTION_ERROR';
export const LOADING_ENTRY = 'LOADING_ENTRY';

export const addEntry = (entry) => {
  return ({
    type: ADD_ENTRY,
    entry
  });
};

const buildFormData = (entryData) => {
  const {
      request_from = '',
      entry_type = 'disbursement',
      vendor_id = '',
      purpose = '',
      effective_date = moment().valueOf(),
      partial_receipt = false,
      regular_book = true,
      line_items = [],
      division_id = '1',
      submitted_user_id = 1,
      selectedEntryDocumentations,
      signature
    } = entryData;
  const formData = new FormData();
  formData.append('effective_date', effective_date);
  formData.append('entry_type', entry_type);
  formData.append('submitted_user_id', submitted_user_id);
  formData.append('purpose', purpose);
  if (typeof signature === "string") {
    formData.append('signature', signature);
  }
  line_items.forEach((item, i) => {
    if (item.created_at) {
      if (item._destroy) {
        formData.append(`line_items_attributes[${i}][_destroy]`, item._destroy);
        formData.append(`line_items_attributes[${i}][id]`, item.id);
      } else {
        formData.append(`line_items_attributes[${i}][id]`, item.id);
        formData.append(`line_items_attributes[${i}][description]`, item.description);
        formData.append(`line_items_attributes[${i}][amount]`, item.amount);
        formData.append(`line_items_attributes[${i}][expense_account_id]`, item.expense_account_id);
      }
    } else {
      formData.append(`line_items_attributes[${i}][description]`, item.description);
      formData.append(`line_items_attributes[${i}][amount]`, item.amount);
      formData.append(`line_items_attributes[${i}][expense_account_id]`, item.expense_account_id);
    }
  });
  if (entry_type === 'disbursement') {
    formData.append('request_from', request_from);
    formData.append('vendor_id', vendor_id);
    formData.append('partial_receipt', partial_receipt);
    formData.append('division_id', division_id);
    for (let i = 0; i < selectedEntryDocumentations.length; i++) {
      const file = selectedEntryDocumentations[i];
      if (file.id) {
        if (file._destroy) {
          formData.append(`documentations_attributes[${i}][id]`, file.id);
          formData.append(`documentations_attributes[${i}][_destroy]`, '1');
        }
      } else {
        formData.append(
          `documentations_attributes[${i}][attachment]`,
          file,
          file.name
        );
      }
    }
  } else {
    formData.append('regular_book', regular_book);
  }
  return formData;
};

export const entryLoading = () => {
  return ({
    type: LOADING_ENTRY
  });
}

export const startAddEntry = (entryData = {}) => {
  return async (dispatch) => {
    try {
      dispatch(entryLoading());
      const docData = buildFormData(entryData);
      let entry = await axios({
        method: 'post',
        url: ENTRIES_ENDPOINT,
        headers: JSON.parse(sessionStorage.user),
        data: docData
      });

      return dispatch(addEntry({
        ...entry.data
      }), history.push('/cashier'));
    } catch (err) {
      console.log(err);
      if (err.response && err.response.status === 422) {
        return dispatch(entryActionError({ errMessage: err.response.data.message }));
      }
      return dispatch(entryActionError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};

export const editEntry = (id, updates) => {
  return ({
    type: EDIT_ENTRY,
    id,
    updates
  });
}

export const startEditEntry = (id, updates) => {
  return async (dispatch) => {
    try {
      const docData = buildFormData(updates);
      // const entry = await axios.put(`${ENTRIES_ENDPOINT}/${id}`, updates);
      let entry = await axios({
        method: 'patch',
        url: `${ENTRIES_ENDPOINT}/${id}`,
        headers: JSON.parse(sessionStorage.user),
        data: docData
      });
      return dispatch(editEntry(entry.data.id, entry.data), history.push('/cashier'));
    } catch (err) {
      return new Error(
        err.response.data.message
      );
    }
  };
};

export const setEntry = (entries) => ({
  type: SET_ENTRIES,
  entries: entries.entries,
  balance: entries.balance
});

export const startSetEntry = ({ startDate = moment().startOf('year'), endDate = moment().endOf('month')}) => {
  return async (dispatch) => {
    try {
      let entries = await axios({
        method: 'get',
        url: `${ENTRIES_ENDPOINT}`,
        headers: JSON.parse(sessionStorage.user)
      });
      return dispatch(setEntry(entries.data));
    } catch (err) {
      if (err.response.status === 401) {
        return dispatch(entryActionError({ errMessage: 'You are not authorized to view entries' }));
      }
      return dispatch(entryActionError(err.response.data.message));
      // return new Error(
      //   err.response.data.message
      // );
    }
  };
};

export const removeEntry = ({
id } = {}) => {
  return ({
    type: REMOVE_ENTRY,
    id
  });
};


export const startRemoveEntry = ({
id } = {}) => {
  return async (dispatch) => {
    try {
      let removedEntry = await axios({
        method: 'delete',
        url: `${ENTRIES_ENDPOINT}/${id}`,
        headers: JSON.parse(sessionStorage.user)
      });
      return dispatch(removeEntry({ id }), history.push('/cashier'));
    } catch (err) {
      return new Error(
        err.response.data.message
      );
    }
  };
};

const entryActionError = (errMessage) => ({
  type: ENTRY_ACTION_ERROR,
  errMessage
});

export const downloadCSV = (entries) => {
  return async (dispatch) => {
    try {
      let entry = await axios({
        method: 'post',
        url: CSV_ENDPOINT,
        headers: JSON.parse(sessionStorage.user),
        data: entries
      });
      return dispatch(formatCSV(entry.data));
    } catch (err) {
      if (err.response && err.response.status === 422) {
        return dispatch(entryActionError({ errMessage: err.response.data.message }));
      }
      return dispatch(entryActionError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};

export const downloadLastCSV = () => {
  return async (dispatch) => {
    try {
      let entry = await axios({
        method: 'get',
        url: LAST_CSV_ENDPOINT,
        headers: JSON.parse(sessionStorage.user)
      });
      return dispatch(formatCSV(entry.data));
    } catch (err) {
      if (err.response && err.response.status === 422) {
        return dispatch(entryActionError({ errMessage: err.response.data.message }));
      }
      return dispatch(entryActionError({ errMessage: 'Please check your connection and try again' }));
    }
  };
};

const formatCSV = (data) => {
  return download(data, `transactions-${moment().format('MM-DD-YYYY, h:mm a')}.csv`);
};



// WEBPACK FOOTER //
// ./src/actions/entryActions.js